<div class="day-of-week">{{ dayOfWeek() }}</div>
<div class="day-of-month">{{ dayOfMonth() }}</div>
